/**
 * Cheeky Frog — jump from a product to its studio
 *
 * The studio lives below the fold on a product page: the page is selling one
 * specific design and has to introduce it first. So the badge over the image
 * and the button in the buy column both bring the customer down to it — and,
 * crucially, put the cursor in the name field, because arriving at a
 * configurator you have not been told how to use is barely better than not
 * arriving at all.
 */
(function () {
  'use strict';

  // Section ids are template-scoped ("template--123__studio"), so match the
  // suffix rather than hardcoding an id that changes per template.
  function studio() {
    return document.querySelector('[id$="__studio"]') ||
           document.querySelector('[data-cf-studio]');
  }

  function focusFirstField(root) {
    // Give the section a moment to build its controls from /v1/designs before
    // reaching for a field that does not exist yet.
    var tries = 0;
    (function attempt() {
      var el = root.querySelector('.cf-studio input[type="text"], .cf-studio input:not([type="hidden"])');
      if (el) { el.focus({ preventScroll: true }); return; }
      if (tries++ < 20) setTimeout(attempt, 150);
    })();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cf-studio-jump]');
    if (!trigger) return;
    var target = studio();
    if (!target) return;
    e.preventDefault();

    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduce ? 'auto' : 'smooth',
      block: 'start',
    });
    focusFirstField(target);
  });
})();
